
import GHIconButton from "../../../components/GHIconButton";
import {useEffect, useState} from "react";
import InstancesService from "../../../services/instances.service";
import {Image} from "react-bootstrap";
import MDBadge from "../../../components/MDBadge";
import {Typography} from "@mui/material";
import {instanceColumns} from "../../../components/Utils/HeaderColumns";
import CustomService from "../../../services/custome.service";

export function useCurrenciesTable(clickItem) {

  const [rows, setRows] = useState([]);

  const columns = [
    { Header: "Name", accessor: "name", width: "20%" },
    { Header: "ShortName", accessor: "short", width: "20%" },
    { Header: "Symbol", accessor: "symbol", width: "20%" },
    { Header: "Actions", accessor: "action", width: "7%" },
  ];

  useEffect(() => {
    CustomService.getCurrencies()
      .then((res) => {
        setRows(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []); 

  return {
    columns,
    rows: rows
      ? rows.map((element) => ({
          id: element.id,
          short: element.short_name,
          name: element.name,
          symbol: element.symbol,
          action: (
            <GHIconButton
              onClick={clickItem}
              id={element.id}
              title="Delete"
              icon="delete"
              size="small"
              color="error"
            />
          ),
        }))
      : [],
  };
}


// const dataTableDataInstance = {
//   columns: [
//
//   ],
//   rows: [
//     {
//       logo: <Image src={logo1} height={75} width={75} thumbnail />,
//       id: "1234-UDF",
//       name: "Core2Dou",
//       client: "12",
//       member: "156",
//       link: "https://google.com/",
//       actions: (
//         <div>
//           <GHIconButton title={"User List"} color={"info"} icon={"list_alt"} size={"medium"}  />
//           <GHIconButton title={"Client List"} color={"secondary"} icon={"dns"} size={"medium"} />
//           <GHIconButton title={"Edit"} color={"warning"} icon={"edit"} size={"medium"} />
//           <GHIconButton title={"Delete"} color={"error"} icon={"delete"} size={"medium"} />
//         </div>
//       ),
//     },
//     {
//       logo: <Image src={logo1} height={75} width={75} thumbnail />,
//       id: "1879-UDF",
//       name: "Electron",
//       client: "44",
//       member: "1560",
//       link: "https://google.com/",
//       actions: (
//         <div>
//           <GHIconButton title={"User List"} color={"info"} icon={"list_alt"} size={"medium"} />
//           <GHIconButton title={"Client List"} color={"secondary"} icon={"dns"} size={"medium"} />
//           <GHIconButton title={"Edit"} color={"warning"} icon={"edit"} size={"medium"} />
//           <GHIconButton title={"Delete"} color={"error"} icon={"delete"} size={"medium"} />
//         </div>
//       ),
//     },
//     {
//       logo: <Image src={logo1} height={75} width={75} thumbnail />,
//       id: "1256-UDF",
//       name: "ThereMoon",
//       client: "12",
//       member: "768",
//       link: "https://google.com/",
//       actions: (
//         <div>
//           <GHIconButton title={"User List"} color={"info"} icon={"list_alt"} size={"medium"} />
//           <GHIconButton title={"Client List"} color={"secondary"} icon={"dns"} size={"medium"} />
//           <GHIconButton title={"Edit"} color={"warning"} icon={"edit"} size={"medium"} />
//           <GHIconButton title={"Delete"} color={"error"} icon={"delete"} size={"medium"} />
//         </div>
//       ),
//     },
//
//   ],
// };
//
// export default dataTableDataInstance;
